import React from "react";
import { Route } from "wouter";
import Header from "./components/Header";
import Home from "./components/Home";
import Other from "./components/Other";
import GlobalStyle from "./GlobalStyle";

import styled from "styled-components";
import Card from "./components/Card";
import Data from "./components/Data";

const Main = styled.main`
  max-width: 1024px;
  margin: auto;

  padding: 2rem 0;
`;

const App = () => {
  return (
    <>
      <GlobalStyle />

      <Main>
        <Header />
        <Card>
          <Route path="/" component={Home} />
          <Route path="/data" component={Data} />
          <Route path="/spinoff" component={Other} />
        </Card>
      </Main>
    </>
  );
};

export default App;
